export default __webpack_public_path__ + "static/media/img-fair-distribution.da8d66e3.jpg";